import { useMutation } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { useActiveOrganization } from "@/hooks/organizations";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export interface CreateCheckoutSessionRequest {
  plan: string;
  success_url: string;
  cancel_url: string;
}

export interface CreateCheckoutSessionResponse {
  success: boolean;
  checkout_session_id: string;
  checkout_session_url: string;
}

export const useCreateCheckoutSession = () => {
  const userToken = useAuth()?.userToken ?? "";
  const activeOrganization = useActiveOrganization();

  return useMutation({
    mutationFn: async ({
      plan,
      success_url,
      cancel_url,
    }: CreateCheckoutSessionRequest): Promise<CreateCheckoutSessionResponse> =>
      fetch(ENDPOINTS.billing.checkout_session, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({
          organization_id: activeOrganization.data?.id,
          plan,
          success_url,
          cancel_url,
        }),
      }).then(handleResponse),
  });
};
